import config from 'config/config';
import io, { Socket } from 'socket.io-client';

export class SocketConnection {
  socket: Socket | null;

  constructor() {
    this.socket = null;
  }

  create = (token: string) => {
    this.socket = io(config.socketHost, {
      withCredentials: config.frontendEnvironment !== 'local',
      path: config.socketPath,
      auth: {
        token: `bearer ${token}`,
      },
    });
  };

  disconnect = () => {
    this.socket?.disconnect();
  };

  connect = (token: string) => {
    if (this.socket?.auth) {
      this.socket.auth = {
        token: `bearer ${token}`,
      };
    }

    this.socket?.connect();
  };
}
